import { withTracker } from 'meteor/react-meteor-data';
import { Meteor } from 'meteor/meteor';
import PropTypes from 'prop-types';
import React from 'react';
import { find, map } from 'lodash';

import Videos from '../../../api/Videos/Videos';

import Loading from '../Loading';
import useTimeStore from '../ZustandProvider';

import AnnotationsMaps from '../AnnotationsMaps/AnnotationsMaps';

const NotesComponent = ({ isAnnotationsMaps, isMobile, loading, videoWithTracker, notesProps }) => {
  if (!isAnnotationsMaps) return '';
  if (loading) return <Loading />;

  const checkCenterAnnotation = useTimeStore(state => state.checkCenterAnnotation);
  const coordinatesAnnotations = useTimeStore(state => state.coordinatesAnnotations);

  const isNotesComponent = true;
  const totalVideo = notesProps.videos.length;
  const firstVideo = find(videoWithTracker, ['_id', notesProps.videos[0]]);
  const listVideosObjects = map(notesProps.videos, element => {
    return find(videoWithTracker, ['_id', element]);
  });

  const [count, setCount] = React.useState(1);
  const [videoSelected, setVideoSelected] = React.useState(firstVideo);
  const [prevVideoSelect, setPrevVideoSelect] = React.useState({});

  const handleChangeVideos = (video, index) => {
    setPrevVideoSelect(videoSelected);
    setCount(index);
    setVideoSelected(video);
  };
  const handlePrevVideoSelected = video => {
    setPrevVideoSelect(video);
  };
  return (
    <>
      <AnnotationsMaps
        checkCenterAnnotation={checkCenterAnnotation}
        coordinatesAnnotations={coordinatesAnnotations}
        countTotalVideo={count}
        gridBackgroundColor="white"
        handleChangeVideos={handleChangeVideos}
        isMobile={isMobile}
        isNotesComponent={isNotesComponent}
        listVideosObjects={listVideosObjects}
        notesProps={notesProps}
        totalVideo={totalVideo}
        videoSelected={videoSelected}
        prevVideoSelect={prevVideoSelect}
        handlePrevVideoSelected={handlePrevVideoSelected}
      />
    </>
  );
};
NotesComponent.defaultProps = {
  videoWithTracker: [],
  isMobile: false
};
NotesComponent.propTypes = {
  isAnnotationsMaps: PropTypes.bool.isRequired,
  videoWithTracker: PropTypes.array,
  loading: PropTypes.bool.isRequired,
  isMobile: PropTypes.bool,
  notesProps: PropTypes.object.isRequired
};
export default withTracker(({ isAnnotationsMaps }) => {
  let videosSub = {};
  if (isAnnotationsMaps) videosSub = Meteor.isClient && Meteor.subscribe('videos.maps');
  return {
    loading: isAnnotationsMaps && !videosSub.ready(),
    videoWithTracker: Videos.find({}, { sort: { name: 1 } }).fetch()
  };
})(NotesComponent);
